// Firebase error codes that indicate permission issues
export const PERMISSION_ERROR_CODES = [
  'permission-denied',
  'PERMISSION_DENIED',
  'functions/permission-denied',
  'auth/permission-denied',
  'storage/unauthorized',
  'storage/insufficient-permissions'
];

// Error codes that indicate authentication issues
export const AUTH_ERROR_CODES = [
  'unauthenticated',
  'UNAUTHENTICATED',
  'functions/unauthenticated',
  'auth/unauthenticated',
  'auth/user-not-found',
  'auth/invalid-credential'
];




